import { selectCardInfo } from '@/../../common/src/api/congraduc';
import CommonLayout from '@/../../common/src/components/CommonLayout';
import { LayoutContext } from '@/../../common/src/components/Layout';
import { nativeApi } from '@/../../common/src/utils/nativeApi';
import { ProductType } from '@/AppGlobal';
import { BankInfoCardStatus } from '@/components/BankCard/BankInfoCard';
import BankInfoCard from '@/components/BankCard/BankInfoCardV2';
import CommonEmpty from '@/components/CommonEmpty';
import { EddaBankInfo } from '@/interface/KKC/edda';
import { BoolString } from '@/interface/KKC/withdrawal';
import { queryAppliedProduction } from '@/pages/CL/credit/api';
import { getGlobalUserInfo } from '@/utils/singletonUtils';
import VhkStore from '@/vhkstore';
import { clearPreEddaData, setBankListLen } from '@/vhkstore/slices/KKC/edda';
import CommonDialog from '@web/common/src/components/CommonDialog';
import { t } from 'i18next';
import { cloneDeep } from 'lodash-es';
import { Popup, Toast } from 'rc-ui-lib';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useQueryParam } from 'use-query-params';
import { updateCardbinding, updateEddaBinding } from '../api';
import { checkEddaStateAndNavigate } from '../commonFunc';
import style from './index.module.less';

export enum EddaParamType {
  SelectType = '2', // type为2时，为KKC需要设立Edda时，从原生弹窗进入的场景，界面弹窗供选择处理。
}

const LOCAL_STORAGE_FROM_EDDA = 'capiFromEdda';

export function ManageEddaV2() {
  const [fromCapi] = useQueryParam<string>('fromCapi');

  const [manageStatus, setManageStatus] = useState(BankInfoCardStatus.DEFAULT);

  const updatePageConfig = useContext(LayoutContext);

  const [banklist, setBankList] = useState<Array<EddaBankInfo>>([]);
  const [tmpBanklist, setTpmBankList] = useState<Array<EddaBankInfo>>([]);

  const [appliedProduction, setAppliedProduction] = useState<ProductType[]>([]);

  const [dialogVisible, setDialogVisible] = useState(false);

  const [inited, setInited] = useState<boolean>(false); // 是否初始化完成

  useEffect(() => {
    if (fromCapi === '1') {
      localStorage.setItem(LOCAL_STORAGE_FROM_EDDA, '1');
    } else {
      localStorage.removeItem(LOCAL_STORAGE_FROM_EDDA);
    }
  }, [fromCapi]);

  useEffect(() => {
    (async () => {
      searchbanklist();
      const tmpAppliedPro = await queryAppliedProduction({ loading: false });
      const tmpProdList = [];
      if (tmpAppliedPro.isApplyKkc === BoolString.YES) {
        tmpProdList.push(ProductType.KKC);
      }
      if (tmpAppliedPro.isApplyCl === BoolString.YES) {
        tmpProdList.push(ProductType.CL);
      }
      if (tmpAppliedPro.isApplyCmc === BoolString.YES) {
        tmpProdList.push(ProductType.CMC);
      }
      setAppliedProduction(tmpProdList);
      setInited(true);
    })();
  }, []);

  useEffect(() => {
    if (banklist.length > 0) {
      if (manageStatus === BankInfoCardStatus.DEFAULT) {
        updatePageConfig({
          rightFontStyle: '#00C34E',
          rightBtnType: t('vcreditprocess_modify'),
          outerLayoutClassName: style.whitebac, // 'whitebac',
          rightFunc: () => {
            setManageStatus(BankInfoCardStatus.MANAGEMENT);
            setTpmBankList(cloneDeep(banklist));
            return true;
          },
          leftFunc: () => {
            nativeApi.closeWindow();
            return true;
          },
        });
      } else {
        updatePageConfig({
          layoutClassName: style.whitebac, // 'whitebac',
          outerLayoutClassName: style.whitebac, // 'whitebac',
          rightFontStyle: '#00C34E',
          rightBtnType: t('common_finish'),
          leftFunc: () => {
            nativeApi.closeWindow();
            return true;
          },
          rightFunc: () => {
            console.log('tmpBanklist12', tmpBanklist);
            // 开始设置默认卡  如果没有默认卡就不执行下面两行代码
            const updateParams = checkIfModify();
            console.log('updateParams', updateParams);
            if (updateParams) {
              updateCardbinding(updateParams).then((res) => {
                if (res === '1') {
                  setShowDialog(true);
                } else {
                  searchbanklist();
                }
              });
            } else {
              setManageStatus(BankInfoCardStatus.DEFAULT);
            }
            return true;
          },
        });
      }
    } else {
      updatePageConfig({
        outerLayoutClassName: style.whitebac, // 'whitebac',
        layoutClassName: style.whitebac, // 'whitebac',
        leftFunc: () => {
          nativeApi.closeWindow();
          return true;
        },
      });
    }
  }, [updatePageConfig, banklist, manageStatus]);

  useEffect(() => {
    const { preEddaData } = VhkStore.getState().eddaReducer;
    setDialogVisible(preEddaData?.type === EddaParamType.SelectType);
    return () => {
      VhkStore.dispatch(clearPreEddaData());
    };
  }, []);

  const navigate = useNavigate();

  const sure = async () => {
    if (banklist.length >= 5) {
      Toast.info({
        message: t('edda.bankcard.limit_cards') || '',
      });
    } else {
      VhkStore.dispatch(setBankListLen({ bankListLen: banklist.length }));
      checkEddaStateAndNavigate({
        navigate,
        manageEddaFunc: () => {
          navigate('/vhk/edda/setedda');
        },
      });
    }
  };

  const checkIfModify = () => {
    // 判断是否有修改默认的卡的情况,并搜集设置的情况
    let isModify = false;
    let msgId = ''; // 获取KKC的默认id
    const msgIdList: {
      msgId: string;
      productCode: ProductType;
    }[] = [];
    banklist.forEach((originBank, idx) => {
      const tmpBank = tmpBanklist[idx];
      if (tmpBank.productList?.some((p) => p.productCode === ProductType.KKC)) {
        msgId = tmpBank.msgId || '';
      }
      if ((tmpBank.productList || []).length > (originBank.productList || []).length) {
        isModify = true;
        (tmpBank.productList || []).forEach((p) => {
          const hasCode = originBank.productList?.some((pt) => p.productCode === pt.productCode);
          if (!hasCode) {
            msgIdList.push({
              msgId: tmpBank.msgId || '',
              productCode: p.productCode,
            });
          }
        });
      }
      if (!msgId) {
        // 先默认随机给一个，这里取最后一个，后端接口的旧逻辑
        msgId = tmpBank.msgId || '';
      }
    });
    return isModify
      ? {
          msgId,
          msgIdList,
        }
      : undefined;
  };

  const searchbanklist = async () => {
    try {
      const resdata = await selectCardInfo(
        {
          type: 1,
        },
        { hideError: true }
      );
      setBankList(resdata);
      setManageStatus(BankInfoCardStatus.DEFAULT);
    } catch (error: unknown) {
      console.error(error);
    }
  };

  const unbindBankCard = (data: EddaBankInfo) => {
    window.showGlobalDialog?.({
      content: t('edda.manage.sure_to_delink'),
      confirmButtonText: t<string, string>('解除'),
      cancelButtonText: t<string, string>('暫不解除'),
      onConfirm: async () => {
        const userInfo = await getGlobalUserInfo();

        const uploaddata = {
          bankCardNumEncrypt: data.bankCardNumEncrypt,
          bankId: data.bankCardCode,
          msgId: data.msgId,
          userName: userInfo.englishName || userInfo.userName,
          mandateId: data.mandateId,
        };
        updateEddaBinding(uploaddata).then((res) => {
          const { msgId } = res;

          navigate(`/vhk/edda/loading?msgId=${msgId}&type=2&bind=2`); //  2代表解绑
        });
      },
    });
  };

  const handleDefaultCheck = (data: EddaBankInfo, type: ProductType) => {
    if ((data.productList || []).findIndex((d) => d.productCode === type) >= 0) {
      return;
    }
    // 更新 tmpBanklist
    const tmpUpdateList = [...tmpBanklist];
    tmpUpdateList.forEach((item) => {
      const idx = item.productList && item.productList.findIndex((d) => d.productCode === type);
      if (typeof idx === 'number' && idx !== -1 && item.id !== data.id) {
        // 找到被取消默认值的数据
        item.productList?.splice(idx, 1);
      }
      if (data.id === item.id) {
        if (item.productList) {
          item.productList.push({ productCode: type });
        } else {
          item.productList = [{ productCode: type }];
        }
      }
    });
    setTpmBankList(tmpUpdateList);
  };

  const goSetEdda = () => {
    setDialogVisible(false);
    navigate('/vhk/edda/setedda');
  };

  const goModifyEdda = () => {
    setDialogVisible(false);
    setManageStatus(BankInfoCardStatus.MANAGEMENT);
    setTpmBankList(cloneDeep(banklist));
  };

  const showBankList = manageStatus === BankInfoCardStatus.DEFAULT ? banklist : tmpBanklist;
  const [showDialog, setShowDialog] = useState(false);
  const gotoMakeCall = () => {
    console.log('call');
    nativeApi.gotoMakeCall?.();
  };
  return inited ? (
    <>
      <CommonDialog
        visible={showDialog}
        content={
          <div>
            {' '}
            <span>{t('你的提现申请')}</span>{' '}
            <span className={style.contact} onClick={gotoMakeCall}>
              (852) 6369 2338{' '}
            </span>{' '}
          </div>
        }
        onConfirm={() => {
          setShowDialog(false);
          // 2. 重置管理状态为默认模式
          setManageStatus(BankInfoCardStatus.DEFAULT);

          // 3. 恢复到原始数据状态，放弃所有未保存的修改
          setTpmBankList(cloneDeep(banklist));
        }}
        confirmButtonText={t<string>('withdrawal_i_know')}
      />
      <div className={style.eddamanagehei}>
        {banklist.length === 0 ? (
          <CommonEmpty type="wxyk" btnClick={() => sure()} />
        ) : (
          <CommonLayout btnText={t('edda.manage.add_new_edda')} onClickBtn={sure}>
            <div className={style.bankpb}>
              {showBankList.map((item, index) => (
                <div className={style.bank} key={`no${item.msgId}`}>
                  <BankInfoCard
                    status={manageStatus}
                    data={{
                      ...banklist[index],
                      bankCardEnName: item.bankEnNameAbbr,
                    }}
                    tmpData={tmpBanklist[index]}
                    onUnbind={unbindBankCard}
                    onSetDefault={handleDefaultCheck}
                    appliedProd={appliedProduction}
                  />
                </div>
              ))}
            </div>
          </CommonLayout>
        )}
      </div>
      <Popup visible={dialogVisible} className={style.dialog_wrapper}>
        <div className={style.dialog_container}>
          <div className={style.dialog_title}>{t('edda.manage.setup_repayment_account')}</div>
          <div className={style.dialog_content}>{t('edda.manage.setup_repayment_account_1')}</div>
          <div className={style.dialog_btn}>
            <span onClick={goModifyEdda}>{t('edda.manage.select_exist_account')}</span>
          </div>
          <div className={style.dialog_btn}>
            <span onClick={goSetEdda}>{t('edda.manage.add_new_account')}</span>
          </div>
        </div>
      </Popup>
    </>
  ) : null;
}
export default ManageEddaV2;
